import { FC } from "react";
import Tab from "@mui/material/Tab";
import CloseIcon from "@mui/icons-material/Close";
import { StyledTabs } from "./styled";

const EmployeesTabs: FC<{
  tab: number;
  setTab: (value: React.SetStateAction<number>) => void;
  selectedEmployees: {
    Id: string;
    Name: string;
    Surname: string;
    Patronymic: string;
    EmploymentDate: string;
    Section: string;
    WorkPosition: string;
    DismissDate: string;
    WorkType: string;
  }[];
  setSelectedEmployees: (
    value: React.SetStateAction<
      {
        Id: string;
        Name: string;
        Surname: string;
        Patronymic: string;
        EmploymentDate: string;
        Section: string;
        WorkPosition: string;
        DismissDate: string;
        WorkType: string;
      }[]
    >
  ) => void;
}> = ({ tab, setTab, selectedEmployees, setSelectedEmployees }) => {
  const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  const handleCloseTab = (id: string) => {
    const elemIndex = selectedEmployees.findIndex((elem) => elem.Id === id);

    const employeesWithoutRemoved = [
      ...selectedEmployees.slice(0, elemIndex),
      ...selectedEmployees.slice(elemIndex + 1),
    ];

    if (tab === 0) {
      setTab(0);
    } else if (employeesWithoutRemoved.length < tab) {
      setTab(employeesWithoutRemoved.length);
    }

    setSelectedEmployees(employeesWithoutRemoved);
  };

  return (
    <StyledTabs
      value={tab}
      onChange={handleChangeTab}
      variant="scrollable"
      scrollButtons="auto"
      aria-label="scrollable auto tabs example"
    >
      <Tab label="Список сотрудников" />
      {selectedEmployees.map((employee) => (
        <Tab
          key={employee.Id}
          label={employee.Name + " " + employee.Surname}
          icon={
            <CloseIcon
              onClick={(event) => {
                handleCloseTab(employee.Id);
                event.stopPropagation();
              }}
            />
          }
          iconPosition="end"
        />
      ))}
    </StyledTabs>
  );
};

export default EmployeesTabs;
